import { render } from "./PollPopup.vue?vue&type=template&id=54249553"
import script from "./PollPopup.vue?vue&type=script&lang=js"
export * from "./PollPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__